<script lang="ts">
    import { Progress } from "sveltestrap";
    export let projectItem 
</script>
<div class="project-status mt-4">
    <div class="media mb-0">
        <p>{projectItem.per}</p>
        <div class="media-body text-end">
            <span>{projectItem.text}</span>
        </div>
    </div>
    <Progress animated={projectItem.boolean} color={projectItem.pcolor} value={projectItem.pvalue} style="height: 5px"></Progress>
</div>
